import { Leaf, Brain, Sun } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SITE } from "../config/site";

const PILLARS = [
  {
    icon: Leaf,
    title: "Body",
    desc: "Listening to the physical terrain: energy, digestion, rest, and the quiet signals your body has been sending.",
    img: SITE.images.pillarBody,
    alt: "Warm sunlight across green botanical leaves",
  },
  {
    icon: Brain,
    title: "Mind",
    desc: "Making space beneath the mental load, untangling overwhelm, worry, and the constant hum of caring for everyone else.",
    img: SITE.images.pillarMind,
    alt: "Soft natural textures in warm light",
  },
  {
    icon: Sun,
    title: "Spirit",
    desc: "Reconnecting with meaning, intuition, and the steady groundedness that makes lasting change possible.",
    img: SITE.images.pillarSpirit,
    alt: "Gentle light through natural foliage",
  },
];

export const Pillars = () => (
  <section id="approach" data-testid="three-pillars-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Overline>The Approach</Overline>
        <h2 className="font-serif text-3xl leading-tight text-forest sm:text-4xl lg:text-5xl">
          Whole-person wellness, <em className="italic text-gold">rooted</em> in real life
        </h2>
        <p className="mt-6 text-lg font-light leading-relaxed text-charcoal/75">
          Health is never just physical. Staci's approach tends to all three roots of
          wellbeing, because lasting change grows from all of them.
        </p>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.12} data-testid={`pillar-${p.title.toLowerCase()}`}>
            <article className="group" data-testid={`pillar-card-${p.title.toLowerCase()}`}>
              <div className="relative overflow-hidden rounded-[2rem]">
                <img
                  src={p.img}
                  alt={p.alt}
                  loading="lazy"
                  className="aspect-[4/4.6] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                />
                <div
                  aria-hidden="true"
                  className="absolute inset-0 bg-gradient-to-t from-forest/35 via-transparent to-transparent"
                />
                <div className="absolute bottom-5 left-5 flex h-12 w-12 items-center justify-center rounded-full bg-ivory/90 backdrop-blur-sm">
                  <p.icon className="h-5 w-5 text-forest" />
                </div>
              </div>
              <h3 className="mt-7 font-serif text-2xl text-forest">{p.title}</h3>
              <p className="mt-3 leading-relaxed text-charcoal/70">{p.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
